<script setup lang="ts">
import { useStorage } from '@vueuse/core';
import { SYSTEM_NOTIFICATION_ENDPOINTS } from '../collections/api/system-notification/system-notification.endpoints';

const { locale } = useI18n();

export interface Banner {
   id: number;
   message: { [key: string]: string };
   type: string;
   created_at: string;
   updated_at: string;
}

// #region get banner
const { data: banner } = useFetch<Banner>(SYSTEM_NOTIFICATION_ENDPOINTS.GET_ALL(), {});
// #endregion

// #region watch banner
const last_active_banner = useStorage<{ banner?: Banner; show: boolean }>('last_active_banner', { show: false });

watch(banner, setBannerOnLoad);
function setBannerOnLoad(fetched_banner?: Banner) {
   if (!fetched_banner) {
      last_active_banner.value = null;
      return;
   }

   if (fetched_banner?.id === last_active_banner.value?.banner?.id) {
      return;
   }

   last_active_banner.value = { banner: fetched_banner, show: true };
}
// #endregion

// #region remove banner
function removeBanner() {
   last_active_banner.value.show = false;
}
// #endregion
</script>

<template>
   <NxtNotificationBanner v-if="banner && last_active_banner?.show" status="warning">
      <div class="banner">
         <span class="banner__message" v-html="banner.message[locale]"></span>
         <NxtIconButton class="banner__icon" :name="'times'" @click="removeBanner()" />
      </div>
   </NxtNotificationBanner>
</template>

<style lang="scss">
.banner {
   display: flex;
   flex-direction: row;
   align-items: center;

   width: 100%;
   height: 100%;
}

.banner__message {
   flex-grow: 1;
}
</style>
